export const BULKY_BACKORDER_MIX_DESCRIPTION =
  "We'll SMS you with a link after purchase to schedule a suitable delivery day.";
export const NON_BULKY_BACKORDER_MIX_DESCRIPTION =
  'Your item(s) will be ordered from supplier after purchase. We will contact you when it becomes available to organise delivery.';
export const NOT_AVAILABILE_WITHIN_RANGE_MESSAGE = 'Sorry, there is no stock within 200km of your store.';
export const CHECK_ALL_DELIVERY_MESSAGE = 'Check all delivery options';
export const CHECK_ALL_INSTORE_MESSAGE = 'Check store availability';
export const NO_INSTORE_AVAILABLE_MESSAGE = 'Sorry, there are no in-store options available for this product.';
export const ONLY_INSTORE_AVAILABLE_MESSAGE = 'Sorry, this product is available to buy in-store only.';
export const NO_DELIVERY_AVAILABLE_MESSAGE = 'Sorry, there are no delivery options available for this product.';
export const DELIVERY_ONLY_MESSAGE = 'Sorry, this product is available for delivery only.';
export const DELIVERY_UNAVAILABLE_MESSAGE = 'Sorry, this product is unavailable for delivery';
export const UNAVAILABLE_MESSAGE = "Sorry, it's unavailable.";
export const ERROR_MESSAGE = "Sorry, we can't load this information right now.";
export const ERROR_MESSAGE_DELIVERY = 'Please change your location or check back later.';
export const ERROR_MESSAGE_PICKUP = 'Please check back later.';
export const ERROR_MESSAGE_UNAVAILABLE = 'Sorry, unable to retrieve availability information for that product.';
export const ERROR_MESSAGE_UNAVAILABLE_INSTORE = 'Sorry, this product is not available in store.';
